import Marquee from "react-fast-marquee";
import { Sprout } from "lucide-react";
import { useContent } from "@/data/content";

export const EditorialMarquee = () => {
  const { ui } = useContent();
  return (
    <div className="py-10 border-y border-ink/10 bg-parchment/60" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ui.marquee.map((w) => (
          <span key={w} className="flex items-center">
            <span className="font-serif italic text-3xl md:text-4xl text-ink/70 px-8">{w}</span>
            <Sprout className="text-clay/50" size={18} strokeWidth={1.25} />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
